import Vue from 'vue';

export default {
  data() {
    return {
      pagamentos: [],
      pagamentosFilteredText: [],
    };
  },
  methods: {
    async getPagamentos() {
      const { data: payments } = await this.$http.post('/inventory.get-payment_mode', {
        modelo: 65,
        active: true,
        requiresEntryPayment: true,
      });

      const mappedPayments = payments.map((payment) => ({
        ...payment,
        isShipay: payment.name.toLowerCase() === 'shipay',
      }));

      try {
        const { data: { status, message } } = await this.$http.post('/fiscal.get-isEnabledModule');
        if (!status && message) {
          Vue.$toast.open({
            message,
            type: 'warning',
            duration: 2000,
          });
        }

        if (!status) {
          this.pagamentos = mappedPayments.filter((payment) => !!payment.isShipay);
          this.pagamentosFilteredText = this.pagamentos;
          return;
        }
      } finally {
        this.pagamentos = mappedPayments;
        this.pagamentosFilteredText = this.pagamentos;
      }
    },
  },
};
